import React from "react";
import { Outlet } from "react-router-dom";

const EventsParentPage = () => {
  return <Outlet />;
};

export default EventsParentPage;
